import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table } from "react-bootstrap";
import { WebcareerscityActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  getAllWebcareerscityAsync,
  deleteWebcareerscityAsync,
} from "../../redux";
import { useIsAccessAllow } from "../../../users/redux";

const WebCareersCityTable = () => {
  const history = useHistory();
  const {
    isLoading,
    webcareerscityList,
    skip,
    limit,
    searchBy,
    searchText,
  } = useSelector((state) => state.webcluescareerscity, shallowEqual);

  useEffect(() => {
    dispatch(getAllWebcareerscityAsync(searchBy, searchText));
    // eslint-disable-next-line
  }, []);

  const dispatch = useDispatch();
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(WebcareerscityActions.setWebcareerscityBatchNumber(count));
  };

  const onEditClick = (data) => {
    history.push(`/web_careers_city/edit-webcareerscity/${data?._id}`);
  };
  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete?")) {
      dispatch(deleteWebcareerscityAsync(data?._id));
      dispatch(getAllWebcareerscityAsync(searchBy, searchText));
    }
  };
  const isEditWebcareerscityAllow = useIsAccessAllow(
    "webcareerscity.edit_webcareerscity"
  );
  const isDeleteAllow = useIsAccessAllow(
    "webcareerscity.delete_webcareerscity"
  );

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Slug</th>
                  <th>Title</th>
                  <th>Created On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {webcareerscityList.records &&
                webcareerscityList.records.length ? (
                  webcareerscityList.records.map(
                    (webcareerscityLists, index) => (
                      <tr key={index}>
                        <td>
                          <span>{skip * limit + (index + 1)}</span>
                        </td>
                        <td>
                          <span>{webcareerscityLists.slug}</span>
                        </td>
                        <td>
                          <span>
                            <span>{webcareerscityLists.title}</span>
                          </span>
                        </td>
                        <td>
                          <span>
                            {new Date(
                              webcareerscityLists.createdOn
                            ).toLocaleString()}
                          </span>
                        </td>
                        <td>
                          {isEditWebcareerscityAllow && (
                            <button
                              title="Edit"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                              onClick={() => onEditClick(webcareerscityLists)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-primary">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Write.svg"
                                  )}
                                />
                              </span>
                            </button>
                          )}

                          {isDeleteAllow && (
                            <button
                              title="Delete"
                              className="btn btn-icon btn-light btn-hover-danger btn-sm"
                              onClick={() => onDeleteClick(webcareerscityLists)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                />
                              </span>
                            </button>
                          )}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {!isLoading && (
            <div className="row d-flex align-items-center mr-5 ml-5 mt-4">
              <div className="col-md-8 text-right mb-5 aspgntn">
                <BasicPagination
                  totalRecords={webcareerscityList.recordsTotal}
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-right">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {webcareerscityList.recordsTotal} Records
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WebCareersCityTable;
